export const useCarModelValidation = ({
  errorMessage,
  isShaking,
  judgePureElectricDrivingRange,
  judgeFuelConsumption,
  OPERATION_TYPE_ENUM,
}) => {
  // 验证车型数据是否完整
  const validateModelData = (data, loading) => {
    // 如果正在加载中，不进行验证
    if (loading) {
      errorMessage.value = ''
      return false
    }

    // 如果没有数据且不在加载中，显示错误信息
    if (!data) {
      errorMessage.value = '请选择有效的车型'
      shake()
      return false
    }

    // 检查车型信息中的必要字段
    const requiredFields = [
      'modelId',
      'modelName',
      'modelState',
      'operationType',
      'operationTypeName',
      'energyType',
      'carLevelFlag',
      'carLevel',
      'modelYear',
      'energyTypeName',
    ]

    // 根据能源类型检查特定字段
    const { energyType, carLevel, operationType, carLevelFlag, carLevelName } =
      data

    if (operationType === OPERATION_TYPE_ENUM.OTHER) {
      errorMessage.value = '请选择有效运营类型的车型, 其他运营类型车辆不支持'
      shake()
      return false
    }

    const missingFields = requiredFields.filter((field) => data[field] === null)

    if (
      operationType === OPERATION_TYPE_ENUM.NETWORK &&
      (!carLevel || !carLevelName || !carLevelFlag)
    ) {
      errorMessage.value =
        '网约车接单资质不完整，请重新选择车型'
      shake()
      return false
    }

    if (missingFields.length > 0) {
      errorMessage.value = '车型信息不完整，请重新选择车型'
      shake()
      return false
    }

    // 检查纯电续航里程
    if (
      judgePureElectricDrivingRange(energyType) &&
      !data.pureElectricDrivingRange
    ) {
      errorMessage.value = '车型信息不完整，缺少纯电续航里程'
      shake()
      return false
    }

    // 检查综合油耗
    if (judgeFuelConsumption(energyType) && !data.fuelConsumption) {
      errorMessage.value = '车型信息不完整，缺少综合油耗'
      shake()
      return false
    }

    // 检查车型图片
    if (!data.carModelPics || !data.carModelPics.length) {
      errorMessage.value = '车型信息不完整，缺少车型图片'
      shake()
      return false
    }

    // 所有验证通过，清除错误信息
    clearError()
    return true
  }

  // 添加抖动方法
  const shake = (message) => {
    if (message) {
      errorMessage.value = message
    }
    isShaking.value = true

    setTimeout(() => {
      isShaking.value = false
    }, 500) // 动画持续时间
  }

  // 清除错误信息的方法
  const clearError = () => {
    errorMessage.value = ''
  }

  return {
    validateModelData,
    shake,
    clearError,
  }
}
